<template>

    <div v-if="questions.length" class="row">
        <div class="col-xl-8 col-lg-7 mt-4">
            <div class="card border-0 shadow rounded p-4 mb-3">

<!--                <div class="alert alert-success" role="alert" v-if="isLastQuestion">-->
<!--                        <h5 class="alert-heading m-0">You have completed all questions!</h5>-->
<!--&lt;!&ndash;                        <p>Click the button below to view your report.</p>&ndash;&gt;-->
<!--                </div>-->

                <div class="alert alert-info mb-2" role="alert" v-if="isEnd()">
                    You have completed exam.
                </div>

                <div class="text-center" v-if="session?.is_completed != true && type === 'mock_exams'">
                    <button class="btn btn-soft-success mb-3 col-md6"
                            @click="showReportPage"
                            v-if="isLastQuestion || isEnd()">End and View report</button>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="dropdown dropdown-primary">
                        <button type="button" class="btn btn-icon btn-soft-primary dropdown-toggle p-0"
                                @click="previousQuestion" :disabled="isFirstQuestion">
                            <i class="ti ti-arrow-left"></i>
                        </button>
                    </div>

                    <div class="d-flex align-items-center">
                        <div class="flex-1 ms-2">
                            <h6 class="mb-0">
                                <question-favorite :question="currentQuestion"
                                                   @update:item="updateFavorite"></question-favorite>
                                Question {{ currentQuestionIndex + 1 + (currentPage - 1) * perPage }} of {{ totalQuestions }}
                            </h6>
                        </div>
                    </div>

                    <div class="dropdown dropdown-primary">
                        <button type="button" class="btn btn-icon btn-soft-primary dropdown-toggle p-0"
                                @click="nextQuestion" :disabled="isLastQuestion" >
<!--                                @click="nextQuestion" :disabled="isLastQuestion" v-if=" ! isLastQuestion">-->
                            <i class="ti ti-arrow-right"></i>
                        </button>

<!--                        <button type="button" class="btn btn-icon btn-soft-success dropdown-toggle p-0"-->
<!--                                @click="nextQuestion" v-if="isLastQuestion" >-->
<!--                            Click en End exam <i class="ti ti-clipboard"></i>-->
<!--                        </button>-->
                    </div>
                </div>

                <CurrentQuestion :currentQuestion="currentQuestion"
                                 :currentAnswerId="currentAnswerId"
                                 :isEnd="isEnd"
                                 :isLastQuestion="isLastQuestion"
                                 @update:nextQuestion="nextQuestion"
                                 :type="type"
                                 @update:currentQuestion="updateCurrentQuestion"
                                 @update:currentAnswerId="updateCurrentAnswerId"/>

            </div>
<!--            <div class="text-center">-->
<!--                <Bootstrap5Pagination-->
<!--                    class="mb-0"-->
<!--                    :data="{-->
<!--                    meta : meta,-->
<!--                }"-->
<!--                    :limit="2"-->
<!--                    :show-disabled="false"-->
<!--                    :size="'default'"-->
<!--                    :align="'center'"-->
<!--                    @pagination-change-page="setCurrentPage"-->
<!--                />-->
<!--            </div>-->
        </div>
        <div class="col-xl-4 col-lg-5 mt-4 rounded">
            <LinksAndMedia
                :currentQuestion="currentQuestion"
                :allQuestions="questionsData"
                :type="type"
                :isEnd="isEnd"
                :result="result"
                :meta="meta"
                @update:currentPage="setCurrentPage($event)"
                @update:changeQuestion="changeQuestion"
            />
        </div>
    </div>
 </template>

<script>
import CurrentQuestion from "./CurrentQuestion.vue";
import LinksAndMedia from "./LinksAndMedia.vue";
import questionFavorite from "../question_favorite/create.vue";

import {Bootstrap5Pagination} from "laravel-vue-pagination";
import RatingButtons from "../share/RatingButtons.vue";

import { useToast } from "vue-toastification";
const toast = useToast();


export default {
    components: {RatingButtons, CurrentQuestion, LinksAndMedia, questionFavorite, Bootstrap5Pagination },
    props: {
        questionsData: {
            type: Array,
            required: true
        },
        meta: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true,
            default: 'session'
        },
        isEnd: {
        },
        session: {
            type: Object,
            required: false,
            default: () => {
                return {
                    is_completed: false,
                }
            }
        },
        result: {
            type: Object,
            required: false,
            default: () => {
                return {
                    result : 0,
                    total_questions : 0,
                    total_correct_questions : 0
                }
            }
        },

    },
    data() {
        return {
            questions: this.questionsData,
            currentQuestionIndex: 0,
            currentAnswerId: null,
            currentPage: this.meta.current_page,
            perPage: this.meta.per_page,
            totalQuestions: this.meta.total,
        };
    },
    computed: {
        currentQuestion() {
            this.currentAnswerId = this.questions[this.currentQuestionIndex]?.answer?.answer_id;
            return this.questions[this.currentQuestionIndex];
        },
        isFirstQuestion() {
            return this.currentQuestionIndex === 0 && this.currentPage === 1;
        },
        isLastQuestion() {
            return this.currentQuestionIndex === this.questions.length - 1 && this.currentPage === Math.ceil(this.totalQuestions / this.perPage);
        }
    },
    methods: {
        setCurrentPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.$emit('fetchQuestions', this.currentPage);
            }
        },
        nextQuestion() {
            this.currentAnswerId = null;
            if (this.currentQuestionIndex < this.questions.length - 1) {
                this.currentQuestionIndex++;
            } else if (this.currentPage < Math.ceil(this.totalQuestions / this.perPage)) {
                this.currentPage++;
                this.$emit('fetchQuestions', this.currentPage);
                this.currentQuestionIndex = 0;
            } else {
                this.showReportPage();
            }
        },
        previousQuestion() {
            this.currentAnswerId = null;
            if (this.currentQuestionIndex > 0) {
                this.currentQuestionIndex--;
            } else if (this.currentPage > 1) {
                this.currentPage--;
                this.$emit('fetchQuestions', this.currentPage);
                this.currentQuestionIndex = this.perPage - 1;
            }
        },
        updateCurrentQuestion(updatedQuestion) {
            this.questions.splice(this.currentQuestionIndex, 1, updatedQuestion);
        },
        updateCurrentAnswerId(newAnswerId) {
            this.currentAnswerId = newAnswerId;
        },
        changeQuestion(question) {
            this.currentAnswerId = null;
            this.currentQuestionIndex = this.questions.findIndex(q => q.id === question.id);
        },
        updateFavorite(newFavorite) {
            this.questions[this.currentQuestionIndex].favorite = newFavorite.favorite ?? null;
        },
        showReportPage() {
            // this.$router.push({ name: 'reportPage' });
            const id = toast.info('saving ...',{ icon: 'fa-solid fa-cloud-arrow-up'  });
            axios.post('mock_exams/endExam',
                {
                    exam_id: this.$route.params?.exam_id,
                    subscribe_id: this.$route.params?.subscribe_id,
                }
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.$emit('update:session', response.data.session);
                this.$emit('update:result', response.data.result);


            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        }
    },
    watch: {
        questionsData(newQuestions) {
            this.questions = newQuestions;
        }
    }
};
</script>

<style scoped>
/* Add any styles specific to the question component here */
</style>
